import { configureStore, Middleware } from '@reduxjs/toolkit';
import { finderSlice } from '../features/finder/finderSlice';
import { landingSlice } from '../features/landing/landingSlice';
import { faqSlice } from '../features/faq/faqSlice';
import { supportSlice } from '../features/support/supportSlice';
import { myBookingSlice } from '../features/myBooking/myBookingSlice';
import { appStateSlice } from '../features/appState/appStateSlice';
import { searchSlice } from '../features/search/searchSlice';
import { bookSlice } from '../features/book/bookSlice';
import { termsSlice } from '../features/terms/termsSlice';
import { contractCustomerSlice } from '../features/contractCustomer/contractCustomerSlice';
import { applySlice } from '../features/apply/applySlice';
import logger from 'redux-logger';
import gatSlice from '../features/gat/gatSlice';
import { gatSessionReducer } from '../features/gat/gatSessionSlice';

const isDevelopment = process.env.NODE_ENV === 'development';

export const store = configureStore({
  reducer: {
    finder: finderSlice.reducer,
    landing: landingSlice.reducer,
    faq: faqSlice.reducer,
    support: supportSlice.reducer,
    myBooking: myBookingSlice.reducer,
    appState: appStateSlice.reducer,
    search: searchSlice.reducer,
    book: bookSlice.reducer,
    terms: termsSlice.reducer,
    contractCustomer: contractCustomerSlice.reducer,
    apply: applySlice.reducer,
    gatInformation: gatSlice.reducer,
    gatSession: gatSessionReducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware();
    if (isDevelopment) {
      middlewares.push(logger as Middleware);
    }
    return middlewares;
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
